var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgXCode(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 48 48",
    width: "240px",
    height: "240px",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#03a9f4",
    d: "M44 38L6.6 43.9 2 13.8 39.2 8.1z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#039be5",
    d: "M39.2 8.1L44 38 6.6 43.9 6.2 41z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#29b6f6",
    d: "M2 13.8L4.4 29.3 22.2 10.7z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M8.3,41.6l-4-26.2l33.3-5.1l4.2,26L8.3,41.6z M6.6,17.1l3.4,22.2l29.5-4.7l-3.5-22.1L6.6,17.1z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M11.1 27L11.5 30 36 26.1 35.5 23.1z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M16.6 34.3L13.5 38l.4-4.8c0-.1 0-.2.1-.3l5.2-12.7c.2-.5.8-.8 1.3-.5l.9.4c.5.2.8.8.5 1.3L16.8 34C16.7 34.1 16.7 34.2 16.6 34.3zM30.7 29.2l-9.3-10.9c-.4-.4-.3-1.1.1-1.4l.8-.6c.4-.4 1.1-.3 1.4.1L33 27.3 30.7 29.2zM33.6 28c0 0 2.4.7 2.4 3.5 0 1.8-.5 2.5-.5 2.5s-.4-1.2-2.3-1.9c-2.6-.9-2.5-2.9-2.5-2.9l2.2-.5L33.6 28z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#03a9f4",
    d: "M20.4 25L19.2 27.9 21.1 26.1 21.5 25z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "#039be5",
    d: "M19.5 30L21.1 26.1 19.2 27.9 18.4 30z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "#03a9f4",
    d: "M15.2 30L17.2 25 16.1 25 14.1 30z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fill: "#039be5",
    d: "M33.9 26.8L30.6 23 29.3 23 32.8 27 33 27.3 30.7 29.2 29.4 27.7 29.4 27.7 26.2 24 24.9 24 27.9 27.5 29.9 29.9 30.6 30.6 31.3 30 33.6 28 34.4 27.4z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fill: "#03a9f4",
    d: "M17 20.9L17 22 22 24.1 22 23z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fill: "#039be5",
    d: "M18 33.6L14.9 32.3 14.1 33.1 18 34.7z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fill: "#03a9f4",
    d: "M13 31.5L13 32.6 14.1 33.1 14.9 32.3z"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fill: "#0277bd",
    d: "M37.9 12.2c0 0 0 .1 0 .1l.7 4.2 1.3-3.6c0-.1.1-.2.1-.3l-.4-2.3C38.8 10.8 38.1 11.6 37.9 12.2zM33.9 32.4c-.2-.1-.4-.2-.7-.3-.5-.2-.8-.3-1.1-.5L30.8 36l2.2-.3L33.9 32.4zM30.2 38.1L29.7 40.3 31.8 39.9 32.4 37.8zM34.8 21.8L34.8 21.9 34.4 23.3 35.5 23.1 35.9 25.3 36.7 22.4 37.2 20.8 36.5 16.4 35.4 19.9z"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    fill: "#90a4ae",
    d: "M36.5 16.4l.7 4.4 1.3-4.3-.7-4.2c-.5 1.4-1 2.8-1.1 3L36.5 16.4zM30.8 36L30.2 38.1 32.4 37.8 33 35.7zM35.9 25.3L35.5 23.1 34.4 23.3 33.5 26.5 35.6 26.2zM33.6 28L33 28.3l-.9 3.3c.3.2.7.4 1.1.5.3.1.5.2.7.3l1-3.6C34.3 28.2 33.6 28 33.6 28z"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    fill: "#0277bd",
    d: "M34.9,28.8l0.7-2.7l-2.2,0.3l-0.6,2.2l0.8-0.7C33.6,28,34.3,28.2,34.9,28.8z"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    fill: "#90a4ae",
    d: "M33.6,28l-0.8,0.7l-0.8,2.9c0.3,0.2,0.7,0.4,1.1,0.5c0.3,0.1,0.5,0.2,0.7,0.3l1-3.6 C34.3,28.2,33.6,28,33.6,28z"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    fill: "#78909c",
    d: "M36,4.5C30,4.5,26,6,26,6v0.5c8.6,0,9.7,3.2,10,4V4.5z"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    fill: "#d7dee2",
    d: "M44,6.3C43.8,6.7,43.6,7,43,7c-1.1,0-2-1.6-2-1.6C39.3,4.3,36,3,33,3c-6,0-8,1.5-8,1.5V5 c4.2,0,5.8,0.4,7.3,1.5c2.4,1.8,2.2,5.9,1.3,9.1L31.8,21l2.9,0.9l2.1-6.6c0.1-0.1,0.6-1.6,1.1-3.1c0.3-0.8,1.1-1.8,2.1-2.1 c0.6-0.2,1.4-0.3,1.9,0.1c0.5,0.4,0.5,0.7,0.4,1.1v0l2,0.6L46,7L44,6.3z"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    fill: "#90a4ae",
    d: "M43,7c-1.1,0-2-1.6-2-1.6l-0.8,2.5c-0.3,1.1-1.5,1.6-2.5,1.3l-4.3-1.4c0.5,0.9,0.7,1.9,0.8,3.1 l3.8,1.2c0.3-0.6,0.8-1.3,1.5-1.7l0,0c0.2-0.1,0.4-0.2,0.6-0.3c0.6-0.2,1.4-0.3,1.9,0.1c0.5,0.4,0.5,0.7,0.4,1.1v0l1.6-5 C43.8,6.7,43.6,7,43,7z"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    fill: "#424242",
    d: "M31.8,21l-8.7,20.3c-0.5,1.3,0.2,2.9,1.6,3.3l0.9,0.3c1.4,0.4,2.8-0.4,3.1-1.4l6-21.6L31.8,21z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgXCode);
export default __webpack_public_path__ + "static/media/XCode.0c2f93db8d3284f1ee9a72be3086addc.svg";
export { ForwardRef as ReactComponent };